(function () {
  "use strict";

  // 100ml x3 Bundle Male & Female — Default Title variant
  var BUNDLE_VARIANT_ID = 45318496846045;
  // Free Mystery 50ml Gift (Bundle Exclusive) — Mystery Fragrance variant
  var GIFT_VARIANT_ID = 57652971340158;
  var POLL_INTERVAL_MS = 2000;
  var syncing = false;

  function notifyCartChanged() {
    // Tell the theme's cart drawer/page to redraw itself, using its own
    // existing refresh logic (it only listens for this event, it doesn't
    // watch the cart directly).
    if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: "bundle-gift-sync" });
    }
  }

  function syncGift() {
    if (syncing) return;
    syncing = true;

    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var bundleQty = 0;
        var giftQty = 0;
        var giftKey = null;

        (cart.items || []).forEach(function (item) {
          if (item.variant_id === BUNDLE_VARIANT_ID) {
            bundleQty += item.quantity;
          }
          if (item.variant_id === GIFT_VARIANT_ID) {
            giftQty += item.quantity;
            giftKey = item.key;
          }
        });

        if (bundleQty > giftQty) {
          return fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              id: GIFT_VARIANT_ID,
              quantity: bundleQty - giftQty,
            }),
          }).then(function (r) {
            if (r.ok) notifyCartChanged();
            return r;
          });
        }

        if (bundleQty < giftQty && giftKey) {
          return fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: giftKey, quantity: bundleQty }),
          }).then(function (r) {
            if (r.ok) notifyCartChanged();
            return r;
          });
        }
      })
      .catch(function (e) {
        console.error("[bundle-gift-sync]", e);
      })
      .then(function () {
        syncing = false;
      })
      .catch(function () {
        syncing = false;
      });
  }

  document.addEventListener("DOMContentLoaded", syncGift);
  document.addEventListener("visibilitychange", syncGift);
  setInterval(syncGift, POLL_INTERVAL_MS);

  if (document.readyState === "complete" || document.readyState === "interactive") {
    syncGift();
  }
})();
